<template>
  <app-modal
    v-bind="$attrs"
    ref="modal"
    class="modal-container"
    content-class="modal-medium"
    title="有効期限通知メッセージ"
  >
    <template v-slot:header="{ ok }">
      <v-card-title class="screen-title">有効期限通知メッセージ</v-card-title>
      <button type="button" aria-label="Close" class="close" @click="ok">
        ×
      </button>
    </template>
    <template v-slot:body="{ ok }">
      <v-card-text class="pa-0">
        <div class="modal-body">
          <v-container>
            <template v-if="login.passwordLimit === 1">
              パスワード有効期限は本日({{
                $filter.date(login.passwordExpiredDate)
              }})までです。<br />
            </template>
            <template v-else-if="login.passwordLimit <= 14">
              パスワード有効期限はあと{{ login.passwordLimit }}日({{
                $filter.date(login.passwordExpiredDate)
              }})です。<br />
            </template>
            パスワード失効前に変更を行ってください。
          </v-container>
        </div>
      </v-card-text>
      <v-divider></v-divider>
      <!-- FOOTER -->
      <v-card-actions>
        <v-list-item class="w-100 pa-1">
          <template v-slot:append>
            <v-btn variant="outlined" color="primary" @click="ok">
              閉じる
            </v-btn>
          </template>
        </v-list-item>
      </v-card-actions>
    </template>
  </app-modal>
</template>

<script lang="ts">
import type { PropType } from "vue";
import { defineComponent } from "vue";
import type { LoginResponse } from "@/apis/AuthApi";

export default defineComponent({
  name: "PasswordExpiredAlert",
  props: {
    /** ログイン結果情報 */
    login: {
      type: Object as PropType<LoginResponse>,
      required: true,
    },
  },
});
</script>
